'use client';

import React, { useCallback, useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { Button } from '@/components/ui/button';
import { Hero } from '@/components/ui/Hero';
import { MotionLink } from '@/components/ui/Motion';
import { URLS } from '@/lib/consts';
import { getImageUrlsByTags } from '@/services/cloudinary';

const MAX_RESULTS = 1;

export default function HomeHero() {
  const queryClient = useQueryClient();

  const tags = useMemo(
    () =>
      `hero${URLS.REQUEST_CONSULTATION.replaceAll(/[\s/-]|(?:%20)/g, '_')}`,
    [],
  );

  const handleOnMouseEnter = useCallback(() => {
    const queryKey = ['get_image_urls_by_tags', MAX_RESULTS, tags];

    const isCached = queryClient.getQueryData(queryKey);

    if (isCached) {
      return;
    }

    queryClient
      .prefetchQuery({
        queryFn: () => getImageUrlsByTags({ maxResults: MAX_RESULTS, tags }),
        queryKey,
      })
      .catch((error: unknown) => error);
  }, [queryClient, tags]);

  return (
    <Hero
      title="Building Your Vision"
      subtitle="Custom homes and renovations crafted with integrity, quality, and a personal touch — right here in Claremore, Oklahoma."
    >
      <Button size="lg" asChild>
        <MotionLink
          href={URLS.REQUEST_CONSULTATION}
          onMouseEnter={handleOnMouseEnter}
        >
          Start Your Project
        </MotionLink>
      </Button>

      <Button
        size="lg"
        variant="outline"
        className="border-white text-white hover:bg-white/10"
        asChild
      >
        <MotionLink href={URLS.PROJECTS}>View Our Work</MotionLink>
      </Button>
    </Hero>
  );
}
